export const ar = {
  task_assigned: {
    title: "تم تعيين مهمة",
    message: "تم تعيين مهمة جديدة لك",
    emailSubject: "تم تعيين مهمة جديدة لك",
  },
  task_unassigned: {
    title: "تم إلغاء تعيين مهمة",
    message: "تمت إعادة تعيين مهمة منك",
    emailSubject: "تمت إزالة مهمة من قائمتك",
  },
  team_task_assigned: {
    title: "تم تعيين مهمة للفريق",
    message: "تم تعيين مهمة لأحد أعضاء فريقك",
    emailSubject: "تم تعيين مهمة للفريق",
  },
  invitation_accepted: {
    title: "تم قبول الدعوة",
    message: "قبل {{name}} دعوتك وانضم بصفته {{role}}",
    emailSubject: "تم قبول الدعوة",
  },
  activity_snooze_expired: {
    title: "انتهاء التأجيل",
    message: "نشاط مؤجل جاهز للمتابعة",
    emailSubject: "انتهاء التأجيل — المهمة جاهز",
  },
  defaultEmailSubject: "إشعار OrderHub",
  emailFooter: "هذه رسالة آلية من OrderHub.",
} as const;
